import { Box, Typography } from "@mui/material";
import React from "react";
import MainDrawer from "../components/MainDrawer";

const PageNotFound = () => {
	return (
		<Box sx={{ display: "flex" }}>
			<MainDrawer index={"null"} />
			<Box
				component="main"
				sx={{
					flex: 1,
					bgcolor: "#fafafa",
					p: 3,
					height: window.innerHeight,
					alignItems: "center",
					justifyContent: "center",
				}}
			>
				{/* <a href="/">Home</a> */}
				<Typography fontWeight="bold">
					401 Unauthorized! Page you are trying to access is restricted!
				</Typography>
			</Box>
		</Box>
	);
};

export default PageNotFound;
